import { render, staticRenderFns } from "./mydetail.vue?vue&type=template&id=daaca8f6&scoped=true&"
import script from "./mydetail.vue?vue&type=script&lang=js&"
export * from "./mydetail.vue?vue&type=script&lang=js&"
import style0 from "./mydetail.vue?vue&type=style&index=0&id=daaca8f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaca8f6",
  null
  
)

export default component.exports